/**
=========================================================
* Material Dashboard 2 PRO React - v2.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-pro-react
* Copyright 2022 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

import { useState, useEffect, useRef, useContext } from "react";

// @mui material components
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import { Autocomplete, Box, Skeleton, Stack } from "@mui/material";

// Material Dashboard 2 PRO React components
import MDBox from "components/MDBox";
import MDButton from "components/MDButton";
import MDTypography from "components/MDTypography";
import MDEditor from "components/MDEditor";

// Material Dashboard 2 PRO React examples
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import FormField from "layouts/applications/wizard/components/FormField";
import { useNavigate, useParams } from "react-router-dom";

import CrudService from "services/cruds-service";
import { MODULE_MASTER } from "utils/constant";
import ModalEntityAddressItemSelect from "cruds/device-management/select-entity";
import AddIdentifier from "../add-identifier";
import { ToastContainer, toast } from 'react-toastify';
import Thresholds from "../thresolds";
import AuthService from "services/auth-service";
import UpdateDeviceSettings from "../update_device_settings";
import SubscriptionDevice from "../subscription_device";
import ContactDeviceAccess from "../contact_device_access";
import ModalEntitySelect from "cruds/device-management/select-entity-main";
import { AuthContext } from "context";
import DownlinkCommandsList from "../DownlinkCommandsList";

const EditDevice = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const authContext = useContext(AuthContext)
  if (authContext.userDetail.role_id == 6 && !authContext.accessList.writeAccess.includes(+id)) {
    navigate('/device-list')
    return
  }
  const [name, setName] = useState({
    text: "",
    error: false,
    textError: "",
  });

  const [deviceType, setDeviceType] = useState([]);
  const [deviceTypes, setDeviceTypes] = useState([]);
  const [entityAddressItem, setEntityAddressItem] = useState([]);
  const [entityAddressItems, setEntityAddressItems] = useState([]);
  const [entityItem, setEntityItem] = useState([]);
  const [statusType, setStatusType] = useState([]);
  const [statusDevice, setStatusDevice] = useState([]);
  const [brand, setBrand] = useState([]);
  const [brands, setBrands] = useState([]);
  const [obrands, setOBrands] = useState([]);
  const [model, setModel] = useState({});
  const [models, setModels] = useState([]);
  const [omodels, setOModels] = useState([]);
  const [typebrand, setTypeBrand] = useState([]);
  const [brandmodel, setBrandModel] = useState([]);
  const [loader, setLoader] = useState(false);
  const [deviceConfig, setDeviceConfig] = useState([])
  const [deviceIdentifier, setDeviceIdentifier] = useState([])
  const [externalDetect, setDetect] = useState(false)
  const [identifer, setIdentifier] = useState([])
  const [identiferItem, setIdentifierItem] = useState([])
  const [selectedThresholds, setSelectedThresholds] = useState([]);
  const [requiredThresholds, setRequiredThresholds] = useState([])
  const [deviceModes, setDeviceModes] = useState([])
  const [modes, setModes] = useState({})
  const [identifierValue, setIdentifierValue] = useState(null)
  const [subscriptionPlanList, setSubscriptionPlanList] = useState([])
  const [formData, setFormData] = useState({
    subscription_id: null,
    auto_renew: 1,
    cancelled_at: null,
    device_id: id,
    end_date: null,
    plan_id: null,
    price_override: null,
    start_date: null,
    status_id: null,
    subscription_source: 'admin'
  });
  const role = useRef(null)
  const selectedContactDeviceAccess = useRef([])
  const [entityList, setEntityList] = useState([])

  useEffect(() => {
    (async () => {
      try {
        const res = await AuthService.getProfile();
        role.current = res.data.attributes.role_id;
      } catch (err) {
        console.error(err);
        return null;
      }
    })();
    (async () => {
      try {
        const response = await CrudService.getDeviceTypes();
        setDeviceTypes(response.data);
      } catch (err) {
        console.error(err);
        return null;
      }
    })();

    (async () => {
      try {
        const response = await CrudService.getStatusTypes(MODULE_MASTER.DEVICES);
        setStatusDevice(response.data);
        setStatusType(response.default_id);
      } catch (err) {
        console.error(err);
        return null;
      }
    })();

    (async () => {
      try {
        const response = await CrudService.getSubscriptionPlanList();
        setSubscriptionPlanList(response.data);
      } catch (err) {
        console.error(err);
        return null;
      }
    })();

    // (async () => {
    //   try {
    //     const response = await CrudService.getEntityAddressItems();
    //     const transformedResponse = response.map(item => ({
    //       ...item,
    //       id: item.address_item_id // Assuming address_item_id is the correct field name in your response
    //     }));

    //     setEntityAddressItems(transformedResponse);
    //   } catch (err) {
    //     console.error(err);
    //     return null;
    //   }
    // })();
  }, []);

  useEffect(() => {
    if (!id) return;

    (async () => {
      try {
        const responseBrands = await CrudService.getDeviceBrands();
        setOBrands(responseBrands.data);

        const responseModels = await CrudService.getDeviceModels();
        setOModels(responseModels.data);

        const responseTypeBrand = await CrudService.getDeviceTypeBrand();
        setTypeBrand(responseTypeBrand.data);

        const responseBrandModel = await CrudService.getDeviceBrandModel();
        setBrandModel(responseBrandModel.data);

        const responseModelConfig = await CrudService.getDeviceModelConfig();
        setDeviceConfig(responseModelConfig.data);

        const response = await CrudService.getDeviceModes();
        if (response.success) {
          setDeviceModes(response.data)
        }

        const res = await CrudService.getDevice(id);
        setDeviceType({ attributes: res.data.attributes?.DeviceType });
        setStatusType({ attributes: { StatusType: res.data.attributes?.StatusOption?.StatusType } });
        setName({ ...name, text: res.data.attributes?.name });

        const responseEntityAddItem = await CrudService.getEntityAddressItems();
        const transformedResponse = responseEntityAddItem.map(item => ({
          ...item,
          id: item.address_item_id // Assuming address_item_id is the correct field name in your response
        }));
        setEntityAddressItems(transformedResponse);
        let role = localStorage.getItem('role') ?? 'Super Admin'
        if (res.data.attributes?.EntityAddressItem) {
          setEntityAddressItem([res.data.attributes?.EntityAddressItem]);
        }
        if (authContext.userDetail.role_id === 1) {
          const entityResponse = await CrudService.getEntities()
          setEntityList(entityResponse.data)
          if (res.data.attributes.entity_id) {
            let filterD = entityResponse.data.filter((e) => e.id == res.data.attributes.entity_id);
            setEntityItem(filterD)
          }
        }
        if (res.data.attributes?.EntityAddressItem && role !== 'Super Admin') {
          const transformedResponse = responseEntityAddItem.filter((e) => e.Entity.entity_id == res.data.attributes?.EntityAddressItem.entity_id).map(item => ({
            ...item,
            id: item.address_item_id // Assuming address_item_id is the correct field name in your response
          }));
          setEntityAddressItems(transformedResponse)
        }


        setBrand({ attributes: res.data.attributes?.DeviceBrand })
        setModel({ attributes: res.data.attributes?.DeviceModel })

        if (res.data.attributes?.DeviceIdentifierValues)
          setDeviceIdentifier(res.data.attributes?.DeviceIdentifierValues)

        if (res.data.attributes?.device_mode_id) {
          setModes(response.data.filter(e => e.mode_id === res.data.attributes?.device_mode_id)[0])
        }

        let resp = await CrudService.getSubscriptionByDeviceId(id)
        if (resp.success) {
          let data = resp.data
          // setSubscription(data)
          setFormData({
            subscription_id: data.subscription_id,
            auto_renew: data.auto_renew,
            cancelled_at: data.cancelled_at,
            end_date: data.end_date,
            plan_id: data.plan_id,
            price_override: data.price_override,
            start_date: data.start_date,
            status_id: data.status_id,
            subscription_source: data.subscription_source
          })
        }

        setLoader(true)

        const filteredtypebrand = responseTypeBrand.data
          .filter((assoc) => assoc.type_id === res.data.attributes?.DeviceType?.device_type_id)
          .map((assoc) => responseBrands.data.find((brand) => brand?.attributes?.brand_id === assoc?.brand_id));
        setBrands(filteredtypebrand);

        const filteredbrandmodel = responseBrandModel.data
          .filter((assoc) => assoc.brand_id === res.data.attributes?.DeviceBrand?.brand_id)
          .map((assoc) => responseModels.data.find((model) => model?.attributes?.model_id === assoc?.model_id));
        setModels(filteredbrandmodel);
        firstTimeHandle(res.data.attributes.model_id, responseModelConfig.data, res.data.attributes.DeviceIdentifierValues)

        setIdentifierValue(res.data.attributes.DeviceIdentifierValues.filter((e) => e.identifier_type_id == 1)[0].value)
        const newDeviceThresholds = res.data.deviceThresholds?.map(
          (threshold) => ({
            ...threshold,
            label: threshold?.DeviceParameter?.parameter_name,
            parameter_name: threshold?.DeviceParameter?.parameter_name,
            is_threshold_required:
              threshold?.DeviceParameter?.is_threshold_required,
            field_type_id: threshold?.DeviceParameter?.field_type_id,
            MessageTemplate: { attributes: threshold?.MessageTemplate },
          })
        );
        setSelectedThresholds(newDeviceThresholds);

      } catch (err) {
        console.error(err);
      }
    })();
  }, [id]);

  const changeNameHandler = (e) => {
    setName({ ...name, text: e.target.value });
  };
  const validateInput = (field_type_id, value) => {
    switch (field_type_id) {
      case 2:
        if (!Number.isInteger(parseInt(value, 10))) {
          return "Value must be an integer";
        }
        break;
      case 3:
        if (!/^-?\d+\.\d+$/.test(value)) {
          return "Value must be a float";
        }
        break;
      case 4:
        if (!["true", "false", "1", "0"].includes(value.toLowerCase())) {
          return "Value must be a boolean (true/false or 1/0)";
        }
        break;
      case 5:
        if (!/^\d{4}-\d{2}-\d{2}$/.test(value)) {
          return "Value must be a valid date (YYYY-MM-DD)";
        }
        break;
      case 6:
        if (!/^\d{4}-\d{2}-\d{2} \d{2}:\d{2}:\d{2}$/.test(value)) {
          return "Value must be a valid datetime (YYYY-MM-DD HH:MM:SS)";
        }
        break;
      case 7:
        if (!/^\d{10}$/.test(value)) {
          return "Value must be a valid timestamp (10 digits)";
        }
        break;
      case 8:
        if (value.length > 255) {
          return "Value must be less than or equal to 255 characters";
        }
        break;
      case 9:
        // Add specific validation logic for list type
        if (!Array.isArray(value)) {
          return "Value must be list";
        }
        break;
      default:
        // No specific validation for other field types
        return null;
    }

    // If validation passes
    return null;
  };

  const identifierSave = async (values) => {
    try {
      const payload = identiferItem.filter((e) => e.is_mapping_key);
      if (!payload.length) {
        toast.info('Is mapping key not found in indetifier', { autoClose: true });
        return;
      }

      const resp = await CrudService.checkImeiExist({ identiferItem: payload[0], device_id: id });
      if (resp.exist) {
        toast.info(resp.msg);
        return; // Exit early if IMEI exists
      }

      const response = await CrudService.upsertDeviceIdentifier({ identifiers: values }, id)

    } catch (error) {
      console.error('identifierSave', error)
      toast.error(error.message)
    }

  }

  const submitHandler = async (e) => {
    e.preventDefault();
    let hasValidationError = false;
    const updatedSelectedThresholds = [...selectedThresholds];
    let list_of_required;
    let thresholdMapped = updatedSelectedThresholds.map((e) => e.id)
    let hasRequiredError = requiredThresholds.every((e) => {
      if (thresholdMapped.includes(e.id)) {
        return true
      }
      list_of_required = e
      return false
    })
    if (!hasRequiredError) {
      toast.info(`Parameter ${list_of_required.DeviceParameter.parameter_name} is required!`)
      return
    }
    updatedSelectedThresholds.forEach((updatedSelectedThreshold) => {
      const validError = validateInput(
        updatedSelectedThreshold?.field_type_id,
        updatedSelectedThreshold?.threshold_value
      );
      updatedSelectedThreshold.validationError = validError;
      if (validError) {
        hasValidationError = validError;
        return;
      }
    });

    setSelectedThresholds(updatedSelectedThresholds);

    if (hasValidationError) return;

    const deviceUpdated = {
      data: {
        type: "devices",
        id: id,
        attributes: {
          name: name.text,
          deviceType: deviceType?.attributes,
          statusType: statusType?.attributes,
          entityAddressItem: entityAddressItem[0],
          brand: brand?.attributes,
          model: model?.attributes,
          deviceParameterThresholds: selectedThresholds,
          mode_id: modes.mode_id,
          contactDeviceAccess: selectedContactDeviceAccess.current,
          entity_id: entityItem.length > 0 ? entityItem[0]?.id : null
        }
      },
    };

    if (externalDetect && identiferItem.filter((e) => e.error === true || e.text == '').length) {
      toast.error('Identifier required')
      return
    }

    // if (externalDetect) {
    //   deviceUpdated.data.attributes.identifier = identiferItem;
    //   deviceUpdated.data.attributes.isExternal = true;
    //   try {
    //     const payload = identiferItem.filter((e) => e.is_mapping_key);
    //     if (!payload.length) {
    //       toast.info('Is mapping key not found in indetifier', { autoClose: true });
    //       return;
    //     }
    //     const resp = await CrudService.checkImeiExist({ identiferItem: payload[0], device_id: deviceUpdated.data.id });
    //     if (resp.exist) {
    //       toast.info(resp.msg);
    //       return; // Exit early if IMEI exists
    //     }

    //     await editDeviceHandler(deviceUpdated);
    //     if (formData.subscription_id) {
    //       await editSubscriptionHandler(formData.subscription_id, formData);
    //     } else if (formData.plan_id) {
    //       await createSubscriptionHandler(formData);
    //     } else {
    //       navigate("/devices", {
    //         state: { value: true, text: "The device was successfully updated" },
    //       });
    //     }
    //   } catch (err) {
    //     console.error(err);
    //     toast.error(err.errors[0].detail ?? 'Something went wrong');
    //   }
    // } else {
    // }
    try {
      await editDeviceHandler(deviceUpdated);
      if (formData.subscription_id) {
        await editSubscriptionHandler(formData.subscription_id, formData);
      } else if (formData.plan_id) {
        await createSubscriptionHandler(formData);
      } else {
        navigate("/devices", {
          state: { value: true, text: "The device was successfully updated" },
        });
      }
    } catch (err) {
      console.error(err);
      toast.error(err.errors[0].detail ?? 'Something went wrong');
    }
  };

  const createSubscriptionHandler = async (payload) => {
    try {
      let resp = await CrudService.createSubscription(payload);
      if (resp.success) {
        navigate("/devices", {
          state: { value: true, text: "The device was successfully updated" },
        });
      }
    } catch (err) {
      console.error(err);
      toast.error(err.error)
    }
  }

  const editDeviceHandler = async (deviceUpdated) => {
    try {
      await CrudService.updateDevice(deviceUpdated, deviceUpdated.data.id);
      // navigate("/devices", {
      //   state: { value: true, text: "The device was successfully updated" },
      // });
    } catch (err) {
      console.error(err);
      toast.error(err.errors[0].detail)
    }
  }

  const editSubscriptionHandler = async (id, payload) => {
    try {
      const resp = await CrudService.updateSubscription(id, payload);
      if (resp.success) {
        navigate("/devices", {
          state: { value: true, text: "The device was successfully updated" },
        });
      }
    } catch (err) {
      console.error(err);
      toast.error(err.error)
    }
  }
  const firstTimeHandle = async (e, deviceConfig, deviceIdenti) => {
    setDetect(false)
    setIdentifierItem([])
    let checkModelExist = deviceConfig.filter(({ model_id }) => model_id === e);
    if (checkModelExist.length) {
      setIdentifier(checkModelExist[0].DeviceConfigIdentifierAssociations)
      checkModelExist[0].DeviceConfigIdentifierAssociations.map((val) => setIdentifierItem((e) => [...e, {
        text: deviceIdenti.filter((e) => e.identifier_type_id === val.DeviceIdentifierType.identifier_type_id)[0]?.value ?? '',
        error: false,
        textError: '',
        regex: val.DeviceIdentifierType.validation_rule,
        association_id: val.association_id,
        name: val.DeviceIdentifierType.identifier_type_name,
        ...val
      }]))
      setDetect(true)
    } else {
      setDetect(false)
      setIdentifierItem([])
    }
  }

  const deviceConfigHandler = async (e) => {
    setIdentifierItem([])
    setDetect(false)
    let checkModelExist = deviceConfig.filter(({ model_id }) => model_id === e.id);

    if (checkModelExist.length) {
      setIdentifier(checkModelExist[0].DeviceConfigIdentifierAssociations)
      checkModelExist[0].DeviceConfigIdentifierAssociations.map((val) => setIdentifierItem((e) => [...e, {
        text: deviceIdentifier.filter((e) => e.identifier_type_id === val.DeviceIdentifierType.identifier_type_id)[0]?.value ?? '',
        error: false,
        textError: '',
        regex: val.DeviceIdentifierType.validation_rule,
        association_id: val.association_id,
        name: val.DeviceIdentifierType.identifier_type_name,
        ...val
      }]))
      setDetect(true)
    } else {
      setDetect(false)
      setIdentifierItem([])
    }
  }

  const handleBrandChange = (event, newBrand) => {
    setBrand(newBrand);
    if (newBrand) {
      const filtered = brandmodel
        .filter((assoc) => assoc.brand_id === newBrand?.attributes?.brand_id)
        .map((assoc) => omodels.find((model) => model?.attributes?.model_id === assoc?.model_id));
      setModels(filtered);
      setModel([])
    } else {
      // Reset filtered brands if no type is selected
      setModels([]);
      setModel([])
    }
  };

  return (
    <DashboardLayout>
      {/* <ToastContainer /> */}
      <DashboardNavbar />
      <MDBox mt={5} mb={9}>
        <Grid container justifyContent="center">
          <Grid item xs={12} lg={8}>
            <MDBox mt={6} mb={8} textAlign="center">
              <MDBox mb={1}>
                <MDTypography variant="h3" fontWeight="bold">
                  Device {id}
                </MDTypography>
              </MDBox>
              <MDTypography variant="h5" fontWeight="regular" color="secondary">
                This information will describe more about the Device.
              </MDTypography>
            </MDBox>
            <Card>
              <MDBox component="form" method="POST" onSubmit={submitHandler}>
                {
                  loader ?
                    <MDBox display="flex" flexDirection="column" px={3} my={2}>
                      <MDBox py={1}>
                        <FormField
                          type="text"
                          label="Name"
                          name="name"
                          value={name.text || ""}
                          onChange={changeNameHandler}
                          error={name.error}
                        />
                        {name.error && (
                          <MDTypography variant="caption" color="error" fontWeight="light">
                            {name.textError}
                          </MDTypography>
                        )}
                      </MDBox>
                      <Autocomplete
                        py={1}
                        defaultValue=""
                        options={deviceTypes}
                        getOptionLabel={(option) => (option.attributes ? option.attributes.type_name : "")}
                        value={deviceType ?? ""}
                        disabled={role.current !== 1}
                        onChange={(event, newdeviceType) => {
                          setDeviceType(newdeviceType);
                          if (newdeviceType) {
                            const filtered = typebrand
                              .filter((assoc) => assoc.type_id === newdeviceType?.attributes?.device_type_id)
                              .map((assoc) => obrands.find((brand) => brand?.attributes?.brand_id === assoc?.brand_id));
                            setBrands(filtered);
                            setBrand([]);
                            setModel([]);
                          } else {
                            // Reset filtered brands if no type is selected
                            setBrands([]);
                            setBrand([]);
                            setModel([]);
                          }

                        }}
                        renderInput={(params) => (
                          <FormField {...params} label="Device Type" InputLabelProps={{ shrink: true }} required />
                        )}
                      />

                      <Autocomplete
                        py={1}
                        defaultValue=""
                        options={brands}
                        getOptionLabel={(option) => (option.attributes ? option.attributes?.brand_name : "")}
                        value={brand ?? ""}
                        onChange={handleBrandChange}
                        disabled={role.current !== 1}
                        renderInput={(params) => (
                          <FormField {...params} label="Device Brand" InputLabelProps={{ shrink: true }} required />
                        )}
                      />

                      <Autocomplete
                        defaultValue=""
                        options={models}
                        getOptionLabel={(option) => (option.attributes ? option.attributes?.model_name : "")}
                        value={model ?? ""}
                        disabled={role.current !== 1}
                        onChange={(event, newModel) => {
                          setModel(newModel);
                          deviceConfigHandler(newModel)
                        }}
                        renderInput={(params) => (
                          <FormField {...params} label="Device Model" InputLabelProps={{ shrink: true }} required />
                        )}
                      />

                      {
                        deviceModes.length ?
                          <Autocomplete
                            defaultValue=""
                            sx={{ paddingBottom: '10px' }}
                            options={deviceModes}
                            getOptionLabel={(option) => (option ? option.mode_name : '')}
                            value={modes ?? ""}
                            onChange={(event, newStatus) => {
                              setModes(newStatus);
                            }}
                            renderInput={(params) => (
                              <FormField {...params} label="Mode" InputLabelProps={{ shrink: true }} />
                            )}
                          /> : ''
                      }

                      <Autocomplete
                        defaultValue=""
                        options={statusDevice}
                        getOptionLabel={(option) => (option.attributes ? option.attributes?.StatusType?.status_name : "")}
                        value={statusType ?? ""}
                        onChange={(event, newStatus) => {
                          setStatusType(newStatus);
                        }}
                        renderInput={(params) => (
                          <FormField {...params} label="Status" InputLabelProps={{ shrink: true }} />
                        )}
                      />
                      {
                        authContext.userDetail.role_id === 1 ?
                          <ModalEntitySelect entityList={entityList} entityItem={entityItem} setEntityItem={setEntityItem} /> : ''
                      }
                      <ModalEntityAddressItemSelect entityAddressItems={entityAddressItems} entityAddressItem={entityAddressItem} setEntityAddressItem={setEntityAddressItem} />
                      {
                        entityAddressItem.length > 0 &&
                        <ContactDeviceAccess selectedContactDeviceAccess={selectedContactDeviceAccess} entity_id={entityAddressItem[0]?.entity_id} address_item_id={entityAddressItem[0]?.address_item_id} />
                      }
                      {
                        model?.attributes?.model_id &&
                        <Thresholds selectedThresholds={selectedThresholds} setSelectedThresholds={setSelectedThresholds} type="edit" model_id={model?.attributes?.model_id} setRequiredThresholds={setRequiredThresholds} />
                      }
                      {externalDetect ?
                        <AddIdentifier identifer={identifer} identiferItem={identiferItem} setIdentifierItem={setIdentifierItem} onSave={identifierSave} /> : <></>}
                      <SubscriptionDevice formData={formData} setFormData={setFormData} subscriptionPlanList={subscriptionPlanList} />
                      <UpdateDeviceSettings device_id={id} identifier={identifierValue} />
                      {
                        model?.attributes &&
                          <DownlinkCommandsList model_id={model?.attributes?.model_id} device_id={id} />
                      }
                      <MDBox ml="auto" mt={4} mb={2} display="flex" justifyContent="flex-end">
                        <MDBox mx={2}>
                          <MDButton
                            variant="gradient"
                            color="dark"
                            size="small"
                            px={2}
                            mx={2}
                            onClick={() =>
                              navigate("/devices", {
                                state: { value: false, text: "" },
                              })
                            }
                          >
                            Back
                          </MDButton>
                        </MDBox>
                        <MDButton variant="gradient" color="dark" size="small" type="submit">
                          Save
                        </MDButton>
                      </MDBox>
                    </MDBox> :
                    <Stack spacing={0.5} sx={{ margin: '20px' }}>
                      <Skeleton variant="rectangular" sx={{ width: '100px', height: '20px' }} />
                      <Skeleton variant="rectangular" sx={{ height: '30px' }} />
                      <Skeleton variant="rectangular" sx={{ width: '100px', height: '20px' }} />
                      <Skeleton variant="rectangular" sx={{ height: '30px' }} />
                      <Skeleton variant="rectangular" sx={{ width: '100px', height: '20px' }} />
                      <Skeleton variant="rectangular" sx={{ height: '30px' }} />
                      <Skeleton variant="rectangular" sx={{ height: '300px' }} />
                    </Stack>
                }
              </MDBox>
            </Card>
          </Grid>
        </Grid>
      </MDBox>
      <Footer />
    </DashboardLayout>
  );
};

export default EditDevice;
